<template>
  <section class="register">
    <div class="box" style="max-width: 500px">
      <div class="header">
        <transition name="title">
          <div v-if="page === 0" key="update" class="title">Ingresso</div>
          <div v-if="page === 1" key="info" class="title">{{ type === 'paid' || type === 'update' || type === 'search' ? 'Vender' : 'Reservar' }}</div>
          <div v-if="page === 2" key="customer" class="title">Clientes</div>
          <div v-if="page === 3" key="new-customer" class="title">Novo Cliente</div>
          <div v-if="page === 4" key="cancel-ticket" class="title">Cancelar Ingresso</div>
          <div v-if="page === 5" key="search-ticket" class="title">Localizar Ingresso</div>
        </transition>
        <div @click="$router.push('/ticket')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <div class="box-content">
        <transition name="page">
          <!-- Ações -->
          <div v-if="page === 0" key="page-0">
            <form @submit.prevent class="form">
              <div style="display: flex; justify-content: space-between; margin-bottom: 15px">
                <label v-if="ticket.seat" class="ticket-seat"><i class="fas fa-chair" style="font-size: 0.8em"></i> {{ ticket.seat }}</label>
                <label v-if="ticket.key" class="ticket-key">{{ ticket.key.substring(0, 3) }}.{{ ticket.key.substring(3) }}</label>
              </div>
              <div class="list-form" style="padding: 10px 5px; background-color: #e5e5e5">
                <div class="form-data" style="text-transform: capitalize">{{ ticket.name || ticket.customerName }}</div>
                <div class="form-data-detail">{{ ticket.email || '' }}</div>
                <div class="form-data-detail">{{ ticket.phone || ticket.customerPhone || '' }}</div>
              </div>
              <!-- Valor -->
              <div style="display: flex; flex-direction: column; margin: 15px 0 0">
                <label>Forma de Pagamento</label>
                <label class="ticket-price" style="font-size: 1.1em">{{ paymentMethodText }}</label>
              </div>
              <div style="display: flex; flex-direction: column; margin: 15px 0">
                <label>{{ ticket.ticketType }}</label>
                <label class="ticket-price">
                  R$ {{ ticket.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}
                </label>
              </div>
              <div v-if="ticket.status === 'pay'" class="nofify warn">
                <i class="fas fa-exclamation-circle"></i>
                <span>O boleto ainda não foi pago</span>
              </div>
              <button @click="print([ticket.id])" type="button" class="button-form"><i class="fas fa-print"></i><span>Imprimir</span></button>
              <button
                type="button"
                @click="page = 4"
                class="button-form"
                v-if="!ticket.tiketera || ['risistemas.com.br', 'tiketera.com.br'].includes(user.login.split('@')[1])"
              >
                <i class="fab fa-creative-commons-nc"></i>
                <span>Cancelar Venda</span>
              </button>
            </form>
          </div>
          <!-- Tipo de Ingresso -->
          <div v-if="page === 1" key="page-1">
            <form @submit.prevent class="form">
              <!-- Diferentes nominações de ingresso -->
              <label v-if="seats.length > 1" class="switch" style="margin: 0 0 15px">
                <input v-model="differentCustomer" @change="differentPrice = true" type="checkbox">
                <span class="slider"></span>
                <span class="text">Diferentes nominações de ingresso</span>
              </label>
              <!-- Ingressos Diferentes -->
              <label v-if="seats.length > 1 && !differentCustomer" class="switch" style="margin: 0 0 15px">
                <input v-model="differentPrice" :disabled="blockDifferentPrice" type="checkbox">
                <span class="slider"></span>
                <span class="text">Diferentes tipos de ingresso</span>
              </label>
              <!-- Pesquisa H-->
              <div v-if="!differentCustomer" style="display: flex; flex-direction: column">
                <label>Pesquisar</label>
                <!--<Autocomplete :model="customerList[0]" :list="customers" placeholder="Pesquise por nome, telefone ou e-mail" />-->
                <Autocomplete :model="customerList[0]" @CustomEventInputChanged="searchCustomer" :list="customers" placeholder="Pesquise por nome, celular ou e-mail" />
              </div>
              <!-- Nome -->
              <div v-if="!differentCustomer" style="display: flex; flex-direction: column; margin-top: 15px">
                <label><span v-if="type !== 'book'" style="color: red">* </span>Nome</label>
                <input v-model="customerList[0].name" :disabled="customerList[0].id && customerList[0].disabled" type="text" placeholder="Nome do cliente" :class="{ error : error.includes('customers-0-name') }" style="text-transform: capitalize" />
                <!-- <Autocomplete :model="customerList[0]" :list="customers" placeholder="Nome do cliente" :class="{ error : error.includes('customers-0-name') }" style="text-transform: capitalize" /> -->
                <div v-if="error.includes('customers-0-name')" class="hint">você esqueceu o nome</div>
              </div>
              <!-- Celular -->
              <div v-if="!differentCustomer" style="display: flex; flex-direction: column; margin-top: 15px">
                <label>Celular</label>
                <input v-model="customerList[0].phone" v-mask="['(##) #####-####']" type="text" :disabled="customerList[0].id && customerList[0].disabled" placeholder="Número do cliente" :class="{ error : error.includes('customers-0-phone') }" />
                <div v-if="error.includes('customers-0-phone')" class="hint">Celular inválido</div>
              </div>
              <!-- E-mail -->
              <div v-if="!differentCustomer" style="display: flex; flex-direction: column; margin-top: 15px">
                <label>E-mail</label>
                <input v-model="customerList[0].email" type="text" :disabled="customerList[0].id" placeholder="E-mail do cliente" :class="{ error : error.includes('customers-0-email') || error.includes('login-exists-0') }" />
                <div v-if="error.includes('customers-0-email')" class="hint">E-mail inválido</div>
                <div v-if="error.includes('login-exists-0')" class="hint">Este usuário já existe! Selecione ele na pesquisa</div>
              </div>
              <!-- Preço -->
              <div v-if="!differentPrice" style="display: flex; flex-direction: column; margin-top: 15px">
                <label><span style="color: red">* </span>Tipo de Ingresso</label>
                <select v-model="prices[0]">
                  <template v-if="prices[0].ticketType.substr(0, 5) === 'Mesa '">
                    <option :value="prices[0]">
                      {{ prices[0].ticketType }}
                    </option>
                  </template>
                  <template v-else>
                    <option
                      v-for="p in ticketTypes.filter(x => x.ticketType.substr(0, 5) !== 'Mesa ')"
                      v-show="p.active"
                      :key="p.key"
                      :value="p"
                      :disabled="disabledOptions(0, p)"
                    >
                      {{ `${p.ticketType} ${disabledOptions(0, p) ? 'ESGOTADO' : ''}` }}
                    </option>
                  </template>
                </select>
              </div>
              <!-- Preços -->
              <div v-if="differentPrice" style="margin-top: 15px">
                <div v-if="!withSection">
                  <div v-for="(s, index) in seats" :key="s" class="list-form">
                    <div class="form-actions">{{ s }}</div>
                    <div class="form-data" style="padding-left: 15px">
                      <!-- Tipo de ingresso -->
                      <select v-model="prices[index]" style="width: 100%">
                        <template v-if="prices[index].ticketType.substr(0, 5) === 'Mesa '">
                          <option :value="prices[index]">
                            {{ prices[index].ticketType }}
                          </option>
                        </template>
                        <template v-else>
                          <option
                            v-for="p in ticketTypes.filter(x => x.ticketType.substr(0, 5) !== 'Mesa ')"
                            :key="p.key"
                            :value="p"
                            :disabled="disabledOptions(index, p)"
                          >
                            {{ `${p.ticketType} ${disabledOptions(index, p) ? 'ESGOTADO' : ''}` }}
                          </option>
                        </template>
                      </select>
                      <!-- Pesquisa -->
                      <Autocomplete v-if="differentCustomer" :model="customerList[index]" :list="customers" placeholder="Pesquise por nome, celular ou e-mail" />
                      <!-- Nome -->
                      <input v-if="differentCustomer" v-model="customerList[index].name" :disabled="customerList[index].id && customerList[index].disabled" type="text" placeholder="Nome do cliente" :class="{ error : error.includes(`customers-${index}-name`) }" style="text-transform: capitalize" />
                      <!-- <Autocomplete v-if="differentCustomer" :model="customerList[index]" :list="customers" placeholder="Nome do cliente" :class="{ error : error.includes(`customers-${index}-name`) }" style="text-transform: capitalize" /> -->
                      <!-- Celular -->
                      <input v-if="differentCustomer" v-model="customerList[index].phone" v-mask="['(##) #####-####']" type="text" :disabled="customerList[index].id && customerList[index].disabled" placeholder="Celular do cliente" :class="{ error : error.includes(`customers-${index}-phone`) }" />
                      <!-- E-mail -->
                      <input v-if="differentCustomer" v-model="customerList[index].email" type="text" :disabled="customerList[index].id" placeholder="E-mail do cliente" :class="{ error : error.includes(`customers-${index}-email`) || error.includes(`login-exists-${index}`) }" />
                      <div v-if="error.includes(`login-exists-${index}`)" class="hint">Este usuário já existe! Selecione ele na pesquisa</div>
                    </div>
                    <div v-if="type === 'paid' || type === 'update'" class="form-actions" style="width: 80px; text-align: right; color: #560070; padding-left: 15px">
                      R$ {{ prices[index].price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div style="display: flex; flex-direction: column; margin-top: 15px">
                    <label>Tipo de ingressos</label>
                  </div>
                  <div v-for="(s, index) in seats" :key="s.id" class="list-form">
                    <div class="form-actions">{{ s.id }} | {{s.section.replace(/_/g, " ") }}</div>
                    <div class="form-data" style="padding-left: 15px">
                      <!-- Tipo de ingresso -->
                      <select v-model="prices[index]" style="width: 100%">
                        <template v-if="prices[index].ticketType.substr(0, 5) === 'Mesa '">
                          <option :value="prices[index]">
                            {{ prices[index].ticketType }}
                          </option>
                        </template>
                        <template v-else>
                          <option
                            v-for="p in ticketTypes.filter(x => x.section === s.section && x.ticketType.substr(0, 5) !== 'Mesa ')"
                            :key="p.key"
                            :value="p"
                            :disabled="disabledOptions(index, p)"
                          >
                            {{
                              p.ticketType + `${ disabledOptions(index, p) ? " ESGOTADO" : "" }`
                            }}
                          </option>
                        </template>
                      </select>
                      <!-- Pesquisa -->
                      <Autocomplete v-if="differentCustomer" :model="customerList[index]" :list="customers" placeholder="Pesquise por nome, celular ou e-mail" />
                      <!-- Nome -->
                      <input v-if="differentCustomer" v-model="customerList[index].name" :disabled="customerList[index].id && customerList[index].name" type="text" placeholder="Nome do cliente" :class="{ error : error.includes(`customers-${index}-name`) }" style="text-transform: capitalize" />
                      <!-- <Autocomplete v-if="differentCustomer" :model="customerList[index]" :list="customers" placeholder="Nome do cliente" :class="{ error : error.includes(`customers-${index}-name`) }" style="text-transform: capitalize" /> -->
                      <!-- Celular -->
                      <input v-if="differentCustomer" v-model="customerList[index].phone" v-mask="['(##) #####-####']" type="text" :disabled="customerList[index].id && customerList[index].phone" placeholder="Celular do cliente" :class="{ error : error.includes(`customers-${index}-phone`) }" />
                      <!-- E-mail -->
                      <input v-if="differentCustomer" v-model="customerList[index].email" type="text" :disabled="customerList[index].id" placeholder="E-mail do cliente" :class="{ error : error.includes(`customers-${index}-email`) || error.includes(`login-exists-${index}`) }" />
                      <div v-if="error.includes(`login-exists-${index}`)" class="hint">Este usuário já existe! Selecione ele na pesquisa</div>
                    </div>
                    <div v-if="type === 'paid' || type === 'update'" class="form-actions" style="width: 80px; text-align: right; color: #560070; padding-left: 15px">
                      R$ {{ prices[index].price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="error.indexOf('seats') > -1" class="hint" style="margin: 10px 0">Quantidade indisponível de ingressos</div>
              <!-- Forma de pagamento -->
              <div v-if="type !== 'book'" style="display: flex; flex-direction: column; margin-top: 15px">
                <label><span style="color: red">* </span>Forma de Pagamento</label>
                <select v-model="paymentMethod" :class="{ error : error.indexOf('paymentMethod') > -1 }">
                  <option :value="null">Selecione a forma de pagamento</option>
                  <option value="cash">Dinheiro</option>
                  <option value="card">Cartão de Crédito</option>
                  <option value="debit">Cartão de Débito</option>
                  <option value="pix">PIX</option>
                  <option value="external">Voucher</option>
                  <option value="courtesy">Cortesia</option>
                </select>
                <div v-if="error.indexOf('paymentMethod') > -1" class="hint">você esqueceu a forma de pagamento</div>
              </div>
              <!-- Valor Recebido -->
              <div v-if="paymentMethod === 'cash'" style="display: flex; justify-content: space-between; margin-top: 15px">
                <div>
                  <label>Valor Recebido</label>
                  <money v-model="calcChange" style="display: block"></money>
                </div>
                <div>
                  <label>TROCO</label>
                  <label class="ticket-price" style="display: block">R$ {{ change.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</label>
                </div>
              </div>
              <!-- Total -->
              <div v-if="type === 'paid' || type === 'update'" style="display: flex; flex-direction: column; margin-top: 15px">
                <label>TOTAL</label>
                <label class="ticket-price">
                  R$ {{ total.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}
                  <span v-if="!differentPrice" class="ticket-price-detail">
                    ({{ prices.length }} ingresso(s) de R${{ prices[0].price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }})
                  </span>
                </label>
              </div>
            </form>
            <div class="actions">
              <button @click="changePage(0)" class="button-previous" style="visibility: hidden"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
              <button @click="saveTicket" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Finalizar</span></button>
            </div>
          </div>
          <!-- Cancelar -->
          <div v-if="page === 4" key="page-4">
            <form @submit.prevent class="form">
              <!-- Motivo do cancelamento -->
              <label>Motivo do cancelamento do ingresso</label>
              <textarea v-model="cancelReason" rows="5" placeholder="Descreva o motivo do cancelamento" :class="{ error : error.indexOf('reason') > -1 }"></textarea>
              <div v-if="error.indexOf('reason') > -1" class="hint">você esqueceu o motivo do cancelamento</div>
            </form>
            <div class="actions">
              <button @click="changePage(0)" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
              <button @click="cancelTicket" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
            </div>
          </div>
          <!-- Pesquisar -->
          <div v-if="page === 5" key="page-5">
            <form @submit.prevent class="form">
              <div style="position: relative">
                <input v-model="searchTickets" type="text" placeholder="Pesquisar..." style="width: 100%; box-sizing: border-box" />
                <i class="fas fa-search ticket-search"></i>
              </div>
              <div style="margin-top: 15px">
                <div v-for="t in filteredTickets" @click="openTicket(t.id, t.status)" :key="t.id" class="list-form hover">
                  <div class="form-data">
                    {{ t.name || t.ticketName }}
                    <span class="form-data-detail" style="display: block">{{ t.login }}</span>
                  </div>
                  <div class="form-action" style="font-size: 1.2rem; font-weight: 400">{{ t.seat || t.key }}</div>
                </div>
              </div>
              <div class="actions">
              </div>
            </form>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { get as getShow } from '../api/showDate'
import { getAllComplete, get as getTicket, create, update, cancel, print } from '../api/ticket'
import { getAllSearch as getCustomersSearch } from '../api/customer'
import { arrayRemoveDupes } from '../../util'
import Autocomplete from './Autocomplete2.vue'

export default {
  name: 'ticket',
  components: { Autocomplete },
  props: ['show', 'seat', 'type', 'section'],
  data () {
    return {
      loading: false,
      page: null,
      error: [],
      differentCustomer: false,
      differentPrice: false,
      prices: [],
      ticketTypes: [],
      withSection: false,
      seats: [],
      customers: [],
      ticket: null,
      cancelReason: null,
      ids: [],
      searchTickets: '',
      tickets: [],
      paymentMethod: null,
      customerList: [],
      calcChange: 0,
      selectedTicketType: '',
      incompleteUser: false,
      blockDifferentPrice: false
    }
  },
  computed: {
    ...mapState(['business', 'user']),

    meia () {
      return this.ticketTypes.filter(x => x.ticketType.toUpperCase().startsWith('MEIA')).reduce((a, c) => {
        a.amount += c.amount
        a.amountsold += c.amountsold
        return a
      }, {
        amount: 0,
        amountsold: 0
      })
    },
    meiaSoldOut () {
      if (this.meia.amountsold === 0 && !(this.seats.length > (this.meia.amount - this.meia.amountsold))) return false
      if (!this.withSection && !this.differentPrice) {
        return this.seats.length > (this.meia.amount - this.meia.amountsold)
      }

      if (this.prices.filter(x => String(x.ticketType).toUpperCase().startsWith('MEIA')).length >= (this.meia.amount - this.meia.amountsold)) return true
      return this.meia.amount - this.meia.amountsold === 0
    },
    total () {
      return this.differentPrice || this.withSection
        ? this.prices.map(x => x.price).reduce((acc, cur) => acc + cur)
        : this.prices[0].price * this.prices.length
    },
    sectionTicketsTypes () {
      if (this.ticketTypes.length === 0) return []
      return arrayRemoveDupes(this.ticketTypes.map(x => x.ticketType))
    },
    filteredTickets () {
      return this.tickets.filter(x =>
        String(x.seat).toLowerCase().includes(this.searchTickets.toLowerCase()) ||
        String(x.key).toLowerCase().includes(this.searchTickets.toLowerCase()) ||
        String(x.name).toLowerCase().includes(this.searchTickets.toLowerCase()) ||
        String(x.ticketName).toLowerCase().includes(this.searchTickets.toLowerCase()) ||
        String(x.login).toLowerCase().includes(this.searchTickets.toLowerCase()) ||
        // eslint-disable-next-line
        String(x.phone).replace(/[- \(\)]/g, '').includes(this.searchTickets.toLowerCase()) ||
        // eslint-disable-next-line
        String(x.ticketPhone).replace(/[- \(\)]/g, '').includes(this.searchTickets.toLowerCase())
      ).filter((x, i) => i < 5)
    },
    paymentMethodText () {
      if (this.ticket.paymentMethod === 'cash') return 'Dinheiro'
      if (this.ticket.paymentMethod === 'card') return 'Cartão de Crédito'
      if (this.ticket.paymentMethod === 'debit') return 'Cartão de Débito'
      if (this.ticket.paymentMethod === 'pix') return 'PIX'
      if (this.ticket.paymentMethod === 'external') return 'Voucher'
      if (this.ticket.paymentMethod === 'courtesy') return 'Cortesia'
      if (this.ticket.paymentMethod === 'tiketera') return 'Tiketera'
      return '-'
    },
    change () {
      return this.calcChange - this.total > 0 ? this.calcChange - this.total : 0
    }
  },
  watch: {
    selectedTicketType (value) {
      this.prices.forEach((price, index) => {
        const ticketType = this.ticketTypes
          .filter(type => type.section === price.section)
          .find(type => type.ticketType === value)

        if (String(value).toUpperCase().startsWith('MEIA') && this.prices.filter(x => String(x.ticketType).toUpperCase().startsWith('MEIA')).length >= (this.meia.amount - this.meia.amountsold)) return false
        this.$set(this.prices, index, ticketType)
      })
    }
  },
  async mounted () {
    try {
      // Show details
      const data = await getShow(this.show)
      this.withSection = data.showDate.find(x => x.id === Number(this.show)).withSection
      this.ticketTypes = data.prices // .filter(x => x.active === true)
      try {
        if (this.withSection) {
          this.seats = JSON.parse(this.seat)
        }
      } catch (error) {
        console.error('without Section')
      }
      // Customers
      /* const customers = await getCustomers()
      this.customers = customers.map(x => {
        x.id = x.userId
        delete x.userId
        return x
      }) */
      // Search
      if (this.type === 'search') {
        this.tickets = await getAllComplete(this.show)
        this.page = 5
      // Info
      } else if (this.type === 'info') {
        this.ticket = await getTicket(this.show, this.seat)
        this.page = 0
      // Update (booked)
      } else if (this.type === 'update') {
        // Ids
        if (this.withSection) this.ids = this.seats.map(x => x.id)
        else this.ids = this.seat.split(',')

        for (const [i, id] of this.ids.entries()) {
          const ticket = await getTicket(this.show, id)
          if (!this.withSection) this.seats.push(ticket.seat)
          this.prices.push(data.prices.find(x => x.id === ticket.showPrice))
          const customer = ticket.user ? this.customers.find(x => x.id === ticket.user) : null
          this.incompleteUser = false
          if (!customer || !customer.name || !customer.phone) {
            this.incompleteUser = true
          }
          this.customerList.push({
            id: customer ? customer.id : null,
            name: customer ? customer.name : ticket.name || '',
            phone: customer ? customer.phone : ticket.phone,
            email: customer ? customer.email : null,
            disabled: this.incompleteUser
          })
          if (i > 0 && this.prices[i - 1].id !== ticket.showPrice) this.differentPrice = true
          if (i > 0 && this.customerList[i - 1].id !== ticket.user) {
            this.differentCustomer = true
            this.differentPrice = true
          }
        }
        if (this.withSection) {
          this.seats = this.seats.map(seat => ({
            id: seat.seat,
            section: seat.section
          }))
        }
        this.page = 1
      // New (paid & book)
      } else {
        // Seats
        if (this.withSection) {
          const tables = this.ticketTypes.filter(x => x.ticketType.substr(0, 5) === 'Mesa ').map(x => ({ seats: Number(x.ticketType.split(' ')[1]), price: x }))
          if (tables) {
            this.prices = this.seats.map((x, i, array) => {
              const table = tables.find(t => t.price.section === x.section && t.seats === array.filter(y => y.id.split('-')[0] === x.id.split('-')[0]).length)
              if (table) {
                return table.price
              } else {
                return data.prices.filter(y => y.section === x.section && y.ticketType.substr(0, 5) !== 'Mesa ')[0]
              }
            })
            const ticketsType = this.prices.map(x => `${x.ticketType} | ${x.section}`).filter((x, i, arr) => arr.indexOf(x) === i)
            if (ticketsType.length > 1) {
              this.differentPrice = true
              this.blockDifferentPrice = true
            }
          } else {
            this.prices = this.seats.map(x => data.prices.filter(y => y.section === x.section)[0])
          }
          this.customerList = this.seats.map(x => ({
            id: null,
            name: '',
            phone: null,
            email: null
          }))
        } else {
          this.seats = this.seat.split(',')
          const tables = this.ticketTypes.filter(x => x.ticketType.substr(0, 5) === 'Mesa ').map(x => ({ seats: Number(x.ticketType.split(' ')[1]), price: x }))
          if (tables) {
            this.prices = this.seats.map((x, i, array) => {
              const table = tables.find(t => t.seats === array.filter(y => y.split('-')[0] === x.split('-')[0]).length)
              if (table) {
                return table.price
              } else {
                return data.prices.filter(y => y.ticketType.substr(0, 5) !== 'Mesa ')[0]
              }
            })
            const ticketsType = this.prices.map(x => x.ticketType).filter((x, i, arr) => arr.indexOf(x) === i)
            if (ticketsType.length > 1) {
              this.differentPrice = true
              this.blockDifferentPrice = true
            }
          } else {
            this.prices = this.seats.map(x => data.prices[0])
          }
          this.customerList = this.seats.map(x => ({
            id: null,
            name: '',
            phone: null,
            email: null
          }))
        }
        this.page = 1
      }
    } catch (error) {
      logger.error(error, this)
    }
  },
  methods: {
    async searchCustomer (value) {
      if (value.length >= 3) {
        // Customers
        const customers = await getCustomersSearch(value)
        this.customers = customers.map(x => {
          x.id = x.userId
          delete x.userId
          return x
        })
      }
    },
    disabledOptions (index, p) {
      let totalAmountSold = 0
      this.ticketTypes.forEach(x => {
        totalAmountSold += x.amountsold
      })
      if (totalAmountSold >= this.business.capacity) return true

      if (this.withSection || this.differentPrice) {
        const result =
          String(p ? p.ticketType : '').toUpperCase().startsWith('MEIA') &&
          !this.prices[index].ticketType.toUpperCase().startsWith('MEIA') &&
          this.prices.filter(x => String(x.ticketType).toUpperCase().startsWith('MEIA')).length >= (this.meia.amount - this.meia.amountsold)
        return result
      } else {
        if (!this.differentPrice && !this.withSection) {
          if (p.ticketType.toUpperCase().startsWith('MEIA') && this.meiaSoldOut) return true
        }
      }
    },
    async openTicket (id, status) {
      this.ticket = await getTicket(this.show, id)
      if (status === 'book') {
        this.ids = [id]
        this.seats.push(this.ticket.seat)
        this.prices.push(this.ticketTypes.find(y => y.id === this.ticket.showPrice))
        this.customer.name = this.ticket.name ? this.ticket.name : ''
        this.customer.phone = this.ticket.phone
        if (this.ticket.user) this.customer = this.customers.find(y => y.userId === this.ticket.user)
        this.page = 1
      } else {
        this.page = 0
      }
    },
    async print (ids, redirect = true) {
      const html = await print(this.business.id, this.show, ids.join(','))
      let script = '<script type="text/javascript">\n'
      script += 'window.onload = function() {\n'
      // script += 'alert(\'Page loaded\');\n'
      script += 'window.print();\n'
      script += 'window.close();\n'
      script += '}\n'
      // eslint-disable-next-line no-useless-escape
      script += '<\/script>'
      // creates iframe to print
      if (document.getElementById('printFrame')) {
        const element = document.getElementById('printFrame')
        element.setAttribute('src', 'data:text/html,' + encodeURIComponent(html + script))
        // document.body.removeChild(document.getElementById('printFrame'))
      } else {
        const element = document.createElement('iframe')
        element.setAttribute('id', 'printFrame')
        element.setAttribute('style', 'display: none')
        element.setAttribute('src', 'data:text/html,' + encodeURIComponent(html + script))
        document.body.appendChild(element)
      }
      if (redirect) this.$router.push('/ticket')
    },
    changePage (page) {
      if (this.loading) return false
      this.page = page
    },
    async saveTicket () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        this.customerList = this.customerList.map(x => {
          delete x.search
          return x
        })
        if (this.type === 'update' || this.type === 'search') {
          // Update ticket
          await update(
            this.ids,
            this.withSection,
            this.differentPrice ? this.prices.map(x => x.id) : [this.prices[0].id],
            1,
            this.seats,
            'paid',
            this.paymentMethod,
            this.differentCustomer ? this.customerList : this.customerList.filter((x, i) => i === 0)
          )
          this.print(this.ids, false)
        } else {
          // Create ticket
          const tickets = await create(
            this.show,
            this.differentPrice || this.withSection ? this.prices.map(x => x.id) : [this.prices[0].id],
            1,
            this.seats,
            this.type,
            this.paymentMethod,
            this.differentCustomer ? this.customerList : this.customerList.filter((x, i) => i === 0)
          )
          if (this.type === 'paid') this.print(tickets.map(x => x.id), false)
        }
        this.loading = false
        this.$router.push('/ticket')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          this.page = 1
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    },
    async cancelTicket () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        // Cancel ticket
        await cancel(this.ticket.id, this.cancelReason)
        this.loading = false
        this.$router.push('/ticket')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
          this.page = 4
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.ticket-price {
  width: auto;
  font-size: 2em;
  font-weight: 400;
  color: $primary-color;
  margin: 0;
}

.ticket-price-detail {
  color: #aaa;
  font-size: 0.5em;
  font-weight: 300;
  text-transform: none;
}

.ticket-seat {
  font-size: 3em;
  font-weight: 500;
  color: $primary-color;
  margin: 0;
}

.ticket-key {
  font-size: 2.6em;
  font-weight: 300;
  color: #aaa;
  margin: 0;
}

.form-data {
  font-size: 1em !important;
  input, select {
    display: block;
    width: 100%;
  }
}

.list-selected {
  background-image: linear-gradient(to right, #0071b3, #0098b3);
  color: #fff;
  border-bottom: 1px solid #fff;
  cursor: pointer;
  .form-data {
    font-size: 1em;
    color: #fff !important;
  }
}

.ticket-search {
  position: absolute;
  top: 10px;
  right: 10px;
  color: $primary-color;
  font-size: 1.5em;
}

.nofify {
  display: flex;
  align-items: center;
  border-radius: 5px;
  color: #fff;
  padding: 15px;
  margin-bottom: 20px;
  background-image: linear-gradient(to bottom right, #aa8200, #d3d327);
  i {
    font-size: 1em;
    margin-right: 15px;
  }
  span {
    font-size: 1em;
    font-weight: 300;
  }
}
</style>
